module.exports = __webpack_public_path__ + "img/banner2.724df244.png";